import { render, staticRenderFns } from "./status.column.header.vue?vue&type=template&id=37ab4191&"
import script from "./status.column.header.vue?vue&type=script&lang=ts&"
export * from "./status.column.header.vue?vue&type=script&lang=ts&"
import style0 from "./status.column.header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports